import * as types from '../mutation-types';
import SystemConfigsAPI from '../../api/systemConfigs';
import GlobalApi from '../../api/global';

export const state = {
  systemcConfig: {},
  allInboxs: [],
};

export const getters = {
  getSystemConfig($state) {
    return $state.systemcConfig;
  },
  // 获取所有的inbox
  getAllInboxsList($state) {
    return $state.allInboxs;
  },
  getInbox: $state => inboxId => {
    const [inbox] = $state.allInboxs.filter(
      record => record.id === Number(inboxId)
    );
    return inbox || {};
  },
};

export const actions = {
  get: async ({ commit }, type) => {
    try {
      const response = await SystemConfigsAPI.get(type);
      commit(types.default.SET_SYSTEM_CONFIG, response.data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  update: async (_, data) => {
    try {
      SystemConfigsAPI.update(data);
    } catch (error) {
      throw new Error(error);
    }
  },
  getAllInboxs: async ({ commit }) => {
    try {
      const response = await GlobalApi.getAllInboxs();
      commit(types.default.SET_ALL_INBOX, response.data.payload);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.default.SET_SYSTEM_CONFIG]($state, config) {
    const { sys_type } = config;
    $state.systemcConfig = {
      ...$state.systemcConfig,
      [sys_type]: config,
    };
  },
  [types.default.SET_ALL_INBOX]($state, payload) {
    $state.allInboxs = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
